import { useMutation } from "@tanstack/react-query";
import { googleSheetsAddonContract } from "@common/contracts/google-sheets-addon.contract";
import { getBackendAPIClient } from "@lib/backendAPIClient";

const googleSheetsAddonClient = getBackendAPIClient(googleSheetsAddonContract);

export function useCompleteGoogleSheetsConnectionMutation() {
    return useMutation({
        mutationFn: async (body: { state: string; code: string }) =>
            await googleSheetsAddonClient.completeConnection({ body }),
    });
}
